/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventfielddates2Inputs */

const en_eventfielddates2 = /** @type {(inputs: Eventfielddates2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date`)
};

const de_eventfielddates2 = /** @type {(inputs: Eventfielddates2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termin`)
};

/**
* | output |
* | --- |
* | "Date" |
*
* @param {Eventfielddates2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventfielddates2 = /** @type {((inputs?: Eventfielddates2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventfielddates2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventfielddates2(inputs)
	return de_eventfielddates2(inputs)
});
export { eventfielddates2 as "eventFieldDates" }